import React, { useState, useEffect } from 'react'
import { Chart } from 'primereact/chart'
import { useAppSelector } from '../../../store/hooks'
import { chartColorVariants, type ChartDataProps } from './chartsUtil'
import ChartContainer from './ChartContainer'

interface LineChartProps {
    data?: ChartDataProps
}

const LineChart = ({ data }: LineChartProps) => {
    const theme = useAppSelector((state) => state.theme.theme)

    const [chartData, setChartData] = useState<ChartDataProps | Record<string, unknown> | undefined>({})
    const [chartOptions, setChartOptions] = useState<Record<string, unknown>>({})

    useEffect(() => {
        const documentStyle = getComputedStyle(document.documentElement)
        const textColor = documentStyle.getPropertyValue(
            theme === 'dark' ? '--bs-white' : '--bs-black'
        )
        const textColorSecondary = documentStyle.getPropertyValue(
            '--text-color-secondary'
        )
        const surfaceBorder =
            documentStyle.getPropertyValue('--bs-border-color')

        const options = {
            maintainAspectRatio: false,
            aspectRatio: 0.6,
            plugins: {
                legend: {
                    labels: {
                        color: textColor,
                    },
                },
            },
            scales: {
                x: {
                    ticks: {
                        color: textColorSecondary,
                    },
                    grid: {
                        color: surfaceBorder,
                    },
                },
                y: {
                    ticks: {
                        color: textColorSecondary,
                    },
                    grid: {
                        color: surfaceBorder,
                    },
                },
            },
        }

        const finalisedChartData = data
        const dataSets = data?.datasets ?? []

        for (let i = 0; i < dataSets.length; i++) {
            const ds = dataSets[i]
            if (!ds) continue
            ds['type'] = 'line'
            ds['borderWidth'] = 1.5
            ds['fill'] = true
            ds['tension'] = 0.5

            const colorVariant = chartColorVariants[i]

            if (colorVariant) {
                ds['borderColor'] =
                    documentStyle.getPropertyValue('--bs-' + colorVariant)
                ds['backgroundColor'] =
                    documentStyle.getPropertyValue('--bs-' + colorVariant) +
                    '10'
            }
        }

        setChartData(finalisedChartData)
        setChartOptions(options)
    }, [theme, data])

    return (
        <ChartContainer>
            <Chart type="line" data={chartData} options={chartOptions} />
        </ChartContainer>
    )
}

export default LineChart
